import { idMapValidation } from "../schema/commonSchema";
import { Ingredient, MoA } from "./basicModels";

MoA.relations = [
  /* -------------------------------------------------------------------------- */
  /*                             Outgoing Relations                             */
  /* -------------------------------------------------------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                             Incoming Relations                             */
  /* -------------------------------------------------------------------------- */
  {
    relatedModel: Ingredient,
    name: "IsMoAOf",
    displayName: "MoA for",
    properties: [],
    schema: idMapValidation,
  },
  /* -------------------------------------------------------------------------- */
  /*                               Self Relations                               */
  /* -------------------------------------------------------------------------- */
  {
    relatedModel: MoA,
    name: "HasChild",
    displayName: "Children",
    properties: [],
    schema: idMapValidation,
  },
  {
    relatedModel: MoA,
    name: "HasParent",
    displayName: "Parents",
    properties: [],
    schema: idMapValidation,
  },
];
export const moAModel = MoA;
